export default __webpack_public_path__ + "static/media/cuckoo.8da0bde2.jpg";